var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3117_5902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.875V14.0625H3.28125C2.50453 14.0625 1.875 13.433 1.875 12.6562C1.875 11.8795 2.50453 11.25 3.28125 11.25H12.1875V0H2.8125C1.78125 0 0.9375 0.84375 0.9375 1.875V13.125C0.9375 14.1562 1.78125 15 2.8125 15H14.0625V1.875H13.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28219 12.1875C3.28172 12.1875 3.28172 12.1875 3.28125 12.1875C3.0225 12.1875 2.8125 12.3975 2.8125 12.6562C2.8125 12.915 3.0225 13.125 3.28125 13.125C3.28172 13.125 3.28172 13.125 3.28219 13.125H12.187V12.1875H3.28219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3117_5902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookImage);
export default __webpack_public_path__ + "static/media/bookImage.1d45f83bcb78487bf355d992b1358f0c.svg";
export { ForwardRef as ReactComponent };